import { render, staticRenderFns } from "./Page_Usecase.vue?vue&type=template&id=cbbffa96"
import script from "./Page_Usecase.vue?vue&type=script&lang=js"
export * from "./Page_Usecase.vue?vue&type=script&lang=js"
import style0 from "./Page_Usecase.vue?vue&type=style&index=0&id=cbbffa96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports